module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-toolbar', {
    staticClass: "md-transparent"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1)], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large navEdit"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h1', {
    staticClass: "navHeading"
  }, [_vm._v(" WorkTeen"), _c('hr', {
    staticClass: "navHR"
  })])])]), _vm._v(" "), _c('div', [_c('md-list', [_c('md-list-item', [_c('md-icon', [_vm._v("home")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("people")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("About Us")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', [_vm._v("android")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/bot"
    }
  }, [_vm._v("Our Bot")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3070bf28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navs.vue
// module id = 893
// module chunks = 1